<div class="patrolling-status-container">
  <!-- Compact Status Box (shown when active session) -->
  <div
    class="patrol-compact-status"
    *ngIf="hasAssignment && activeSession"
    (click)="openDetailsDrawer()"
  >
    <div class="status-header">
      <div class="status-icon">
        <mat-icon
          [fontIcon]="
            unresolvedViolations.length > 0 ? 'warning' : 'directions_car'
          "
        ></mat-icon>
        <span class="pulse-dot" *ngIf="isMonitoring"></span>
      </div>
      <div class="status-info">
        <div class="status-title">Active Patrol</div>
        <div class="status-geofence">{{ activeSession.geofenceName }}</div>
      </div>
      <button mat-icon-button class="expand-btn">
        <mat-icon>chevron_right</mat-icon>
      </button>
    </div>

    <div class="status-metrics">
      <div class="metric">
        <div class="metric-value">{{ sessionDuration }}</div>
        <div class="metric-label">Duration</div>
      </div>
      <div class="metric">
        <div class="metric-value">{{ totalChecks }}</div>
        <div class="metric-label">Checks</div>
      </div>
      <div class="metric">
        <div
          class="metric-value"
          [style.color]="
            complianceRate >= 90
              ? '#52c41a'
              : complianceRate >= 70
              ? '#faad14'
              : '#ff4d4f'
          "
        >
          {{ complianceRate.toFixed(0) }}%
        </div>
        <div class="metric-label">Compliance</div>
      </div>
      <div class="metric" *ngIf="unresolvedViolations.length > 0">
        <div class="metric-value" style="color: #ff4d4f">
          {{ unresolvedViolations.length }}
        </div>
        <div class="metric-label">Violations</div>
      </div>
    </div>

    <div class="status-progress">
      <mat-progress-bar
        mode="determinate"
        [value]="complianceRate"
        [color]="
          complianceRate >= 90
            ? 'primary'
            : complianceRate >= 70
            ? 'accent'
            : 'warn'
        "
      ></mat-progress-bar>
    </div>
  </div>

  <!-- Floating Icon Button (shown when no active session) -->
  <button
    *ngIf="hasAssignment && !activeSession"
    mat-fab
    class="patrol-floating-btn"
    [class.violation]="unresolvedViolations.length > 0"
    (click)="openDetailsDrawer()"
    [disabled]="loading$ | async"
  >
    <div class="patrol-icon-wrapper">
      <mat-icon
        [fontIcon]="
          unresolvedViolations.length > 0 ? 'warning' : 'directions_car'
        "
      ></mat-icon>

      <div class="violation-badge" *ngIf="unresolvedViolations.length > 0">
        {{ unresolvedViolations.length }}
      </div>
    </div>

    <div class="patrol-tooltip">
      <div class="tooltip-title">
        <mat-icon
          style="margin-right: 4px; font-size: 16px; width: 16px; height: 16px"
          >directions_car</mat-icon
        >
        Patrol Status
      </div>
      <div class="tooltip-content">
        <div class="tooltip-item">
          <span class="label">Status:</span>
          <span class="value inactive">No Active Session</span>
        </div>
        <div class="tooltip-item" *ngIf="unresolvedViolations.length > 0">
          <span class="label">Violations:</span>
          <span class="value warning">
            {{ unresolvedViolations.length }} Unresolved
          </span>
        </div>
      </div>
    </div>
  </button>

  <!-- No Assignment Button -->
  <button
    *ngIf="!hasAssignment"
    mat-fab
    class="patrol-floating-btn inactive"
    (click)="openDetailsDrawer()"
  >
    <div class="patrol-icon-wrapper">
      <mat-icon>directions_car</mat-icon>
    </div>

    <div class="patrol-tooltip">
      <div class="tooltip-title">
        <mat-icon
          style="margin-right: 4px; font-size: 16px; width: 16px; height: 16px"
          >cancel</mat-icon
        >
        No Patrol Assignment
      </div>
      <div class="tooltip-content">
        <span class="no-assignment">You have no patrol assignments</span>
      </div>
    </div>
  </button>
</div>
